import * as tslib_1 from "tslib";
import { OnInit, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Subject } from "rxjs/index";
import { BsModalRef } from 'ngx-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { TimelineService } from "@app/shared/services/timeline.service";
import { TABLETYPES } from "@app/config";
import { HttpClient } from "@angular/common/http";
import { GetSelect2FileTagsOptions } from "@app/utils";
import { GetJobApiUrl } from "@app/utils/get-job-api-url";
var ViewAttachFilesComponent = /** @class */ (function () {
    function ViewAttachFilesComponent(ts, bsModalRef, sanitizer, http, cdr) {
        this.ts = ts;
        this.bsModalRef = bsModalRef;
        this.sanitizer = sanitizer;
        this.http = http;
        this.cdr = cdr;
        this.previewableImageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
        this.previewableVideoTypes = ['mp4', 'webm', 'ogg', 'ogv', 'm4v'];
        this.action = '';
        this.selectedTags = [];
        this.isTagUpdated = false;
        this.showTagDropDown = false;
        this.mode = '';
    }
    ViewAttachFilesComponent.prototype.ngOnInit = function () {
        this.filesArray;
        this.clone;
        this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(this.clone.fileLocation);
        this.onClose = new Subject();
        this.clone['createdDateTime'] = this.ts.convertTimeLineDateTime(this.clone['createdDateTime']);
        if (this.showTagDropDown) {
            this.tagsSelect2Config = GetSelect2FileTagsOptions();
        }
    };
    ViewAttachFilesComponent.prototype.ngAfterViewInit = function () {
        if (this.showTagDropDown) {
            if (this.clone.hasOwnProperty('tags') && this.clone.tags.length) {
                this.tagsSelect2Config['data'] = this.clone.tags;
                $(this.select2FileTags.nativeElement).select2('data', this.clone.tags);
            }
        }
    };
    ViewAttachFilesComponent.prototype.keyEvent = function (event) {
        if (event.keyCode == 39 || event.keyCode == 40) { //right and down key
            this.fileRightArrow();
        }
        else if (event.keyCode == 37 || event.keyCode == 38) { //left and up key
            this.fileLeftArrow();
        }
    };
    ViewAttachFilesComponent.prototype.fileRightArrow = function () {
        if (this.filesArray.length > 0 && this.filesArray.length - 1 > this.index) {
            this.index++;
            this.selectedIndex(this.index);
        }
    };
    ViewAttachFilesComponent.prototype.fileLeftArrow = function () {
        if (this.filesArray.length > 0 && this.index > 0) {
            this.index--;
            this.selectedIndex(this.index);
        }
    };
    ViewAttachFilesComponent.prototype.selectedIndex = function (currentIndex) {
        if (this.filesArray[currentIndex]) {
            var findNextImage = this.filesArray[currentIndex];
            this.clone = tslib_1.__assign({}, this.clone, findNextImage, { createdDateTime: this.ts.convertTimeLineDateTime(findNextImage['createdDateTime']) });
            this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(findNextImage['fileLocation']);
            this.cdr.detectChanges();
        }
    };
    ViewAttachFilesComponent.prototype.attachFileDownload = function (imageSrc) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var image, imageBlog, imageURL, link;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(imageSrc)];
                    case 1:
                        image = _a.sent();
                        return [4 /*yield*/, image.blob()];
                    case 2:
                        imageBlog = _a.sent();
                        imageURL = URL.createObjectURL(imageBlog);
                        link = document.createElement('a');
                        link.href = imageURL;
                        link.download = this.clone.fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewAttachFilesComponent.prototype.selectedTag = function (tag) {
        this.selectedTags = tag;
        this.isTagUpdated = true;
    };
    ViewAttachFilesComponent.prototype.save = function () {
        var _this = this;
        this.action = 'saving';
        var postParams = {};
        if (this.isTagUpdated) {
            var formData_1 = new FormData();
            this.selectedTags.forEach(function (tag) {
                formData_1.append('tags[]', tag.toString());
            });
            this.http.post(GetJobApiUrl('e5ec7051/addEditFileTags'), { tags: this.selectedTags, tableType: TABLETYPES.ATTACHED_FILES, fileId: this.clone['attachedId'] }).subscribe(function (res) {
                _this.onClose.next();
                _this.bsModalRef.hide();
            }, function (error) {
                _this.action = '';
            }, function () {
                _this.action = '';
            });
        }
        else {
            this.bsModalRef.hide();
        }
    };
    ViewAttachFilesComponent.prototype.openSidePanel = function (type) {
        if (type == 'email') {
            type = this.clone;
        }
        this.onClose.next(type);
        this.bsModalRef.hide();
    };
    ViewAttachFilesComponent.prototype.updateFileData = function (newData) {
        this.clone = tslib_1.__assign({}, newData, { createdDateTime: this.ts.convertTimeLineDateTime(newData['createdDateTime']) });
        this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(this.clone.fileLocation);
        this.cdr.detectChanges();
        // if (this.clone.hasOwnProperty('tags') && this.clone.tags.length) {
        //     this.tagsSelect2Config['data'] = this.clone.tags;
        //     $(this.select2FileTags.nativeElement).select2('data', this.clone.tags);
        // } else {
        //     this.tagsSelect2Config['data'] = [];
        //     $(this.select2FileTags.nativeElement)
        //         .val(null)
        //         .trigger('change');  // notify Select2 to refresh UI
        // }
    };
    ViewAttachFilesComponent.prototype.isPreviewableImage = function (file) {
        var fileType = file && file.fileType ? file.fileType.toString().toLowerCase() : '';
        return this.previewableImageTypes.indexOf(fileType) !== -1;
    };
    ViewAttachFilesComponent.prototype.isPreviewableVideo = function (file) {
        var fileType = file && file.fileType ? file.fileType.toString().toLowerCase() : '';
        return this.previewableVideoTypes.indexOf(fileType) !== -1;
    };
    ViewAttachFilesComponent.prototype.getVideoMimeType = function (file) {
        var fileType = file && file.fileType ? file.fileType.toString().toLowerCase() : '';
        if (fileType === 'mp4' || fileType === 'm4v') {
            return 'video/mp4';
        }
        if (fileType === 'webm') {
            return 'video/webm';
        }
        if (fileType === 'ogg' || fileType === 'ogv') {
            return 'video/ogg';
        }
        return 'video/mp4';
    };
    ViewAttachFilesComponent.prototype.isNoPreviewDocument = function (file) {
        var rawFileType = file && file.fileType ? file.fileType.toString().toLowerCase() : '';
        if (!rawFileType) {
            return false;
        }
        return rawFileType === 'xls'
            || rawFileType === 'xlsx'
            || rawFileType === 'csv'
            || rawFileType === 'xml'
            || rawFileType === 'text/xml'
            || rawFileType === 'application/xml';
    };
    return ViewAttachFilesComponent;
}());
export { ViewAttachFilesComponent };
